import React from 'react';
import { noopFunction } from '../util';
export var HawkinsContext = React.createContext({
    compact: undefined,
    defaultClasses: {},
    defaultProps: {},
    hideDeprecationWarnings: undefined,
    loading: undefined,
    setTheme: noopFunction,
    theme: undefined,
    themeObject: {},
});
HawkinsContext.displayName = 'HawkinsContext';
/**
 * A hook for accessing the current Hawkins context, which is defined by the [HawkinsProvider](/components-hawkins-provider).
 */
export function useHawkinsContext() {
    return React.useContext(HawkinsContext);
}
useHawkinsContext.displayName = 'useHawkinsContext';
//# sourceMappingURL=useHawkinsContext.js.map